import { SOMETHING_WENT_WRONG } from '@nykaa/my-profile-shared/constants';
import {
  SendMappingOTPError,
  SendMappingOTPStatus,
  SendMappingOTPResponse,
} from 'User/types/emailVerification';
import { statusMessages } from 'shared/constants/statusCodes';
import {
  SEND_MAPPING_OTP_API_ERROR,
  GET_EMAIL_MAPPING_STATUS_ERROR,
  prefixForEmailVeriErrorLogs,
} from 'User/store/emailVerification/constants/errorMessages';

export const transformSendMappingOtp = (
  error: null | Error,
  apiResponse: any
): SendMappingOTPResponse => {
  if (error) {
    /**
     * HANDLE NETWORK ERROR
     * In this case we prompt the user that some Network error has happened
     */
    return {
      error: {
        errorToLog: `${error.response?.status} ${prefixForEmailVeriErrorLogs.NETWORK_ERROR}:${GET_EMAIL_MAPPING_STATUS_ERROR}`,
        messageToDisplay:
          error?.response?.data?.message || SOMETHING_WENT_WRONG,
        type: SendMappingOTPError.NETWORK_ERROR,
      },
    };
  }

  const { status, data, message } = apiResponse;

  if (status === statusMessages.SUCCESS) {
    /**
     * This covers send OTP success cases
     * as well as some OTP related errors like
     * - Could not send OTP. Please retry after sometime
     * - Retry limit exceeded. Please try again after 5 mins!
     */
    const { otpId, retryAllowed } = data;

    // When otpStatus !success
    let errorPrefix = prefixForEmailVeriErrorLogs.UNKNOWN;
    if (retryAllowed === 0) {
      errorPrefix = prefixForEmailVeriErrorLogs.RETRIES_EXHAUSTED;
      return {
        error: {
          errorToLog: `${errorPrefix}:${SEND_MAPPING_OTP_API_ERROR}`,
          messageToDisplay: message,
          type: SendMappingOTPError.RETRIES_EXHAUSTED,
        },
      };
    }

    return {
      otpId,
      message,
      status: SendMappingOTPStatus.SUCCESS,
    };
    // return {
    //   retriesLeft,
    //   message,
    //   status: (retriesLeft === 0) ? SendMappingOTPStatus.RETRIES_EXHAUSTED : SendMappingOTPStatus.OTHERS,
    // };
  }

  /**
   * The following case handles - Errors in User/Mobile number validation
   * Authentication failed
   * Invalid Login Method
   * Retry count exceeded
   */
  const { editingAllowed, error: errorCode } = data || {};

  let prefixForErrorToLog = '';
  let errorType: SendMappingOTPError = SendMappingOTPError.OTHER_ERROR;

  switch (true) {
    case errorCode === 1006:
      // If attempts to enter new email increases, Rate Limiter check
      prefixForErrorToLog = prefixForEmailVeriErrorLogs.SUSPICIOUS;
      errorType = SendMappingOTPError.RATE_LIMIT;
      break;

    default:
      // Authentication Failed or any other error
      prefixForErrorToLog = prefixForEmailVeriErrorLogs.AUTHENTICATION_FAILED;
      break;
  }

  return {
    error: {
      errorToLog: `${prefixForErrorToLog}: ${SEND_MAPPING_OTP_API_ERROR}`,
      messageToDisplay: message,
      type: errorType,
    },
    isEditable: !!editingAllowed,
  };
};
